import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Header } from "../../../components/header/Header";
import { SketchDetails } from "../../../components/sketch_details/SketchDetails";
import { createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { getContestDetailThunk as onGetContestDetailThunk } from "../../../slices/contest/thunk";
import {
  getContestCommentsThunk as onGetContestComments,
  saveContestCommentsThunk as onSaveContestComments,
} from "../../../slices/comments/thunk";
import { CommentCheck } from "../../../components/comment/CommentCheck";

import { getRole } from "../../../utils/GetRole";
import { getUserSubscribePlan } from "../../../utils/GetAuthUser";
import { CountdownTimer } from "../../contest/CountdownTimer";
import CreateContest from "./CreateContest";
import { SketchResult } from "../../users/uploadimage/create_contest/SketchResult";
import ContestMessage from "./ContestMessage";

export const AdminContestDetail = () => {

  const dispatch = useDispatch();
  const [contestDetail, setContestDetail] = useState(null);
  const [isShowTimer, setIsShowTimer] = useState(false);
  const { contestId } = useParams();
  const userSubscribePlan = getUserSubscribePlan();
  const { role } = getRole();


  const [isPremiumUser, setIsPremiumUser] = useState(false);

  const selectContestState = (state) => state.contest;
  const contestSelector = createSelector(selectContestState, (contest) => ({
    contestList: contest.contestList,
  }));

  const selectCommentsState = (state) => state.comments;
  const commentsSelector = createSelector(selectCommentsState, (comments) => ({
    comments: comments.comments,
    isLoading: comments.isLoading,
    isSaving: comments.isSaving,
    isCommentSave: comments.isCommentSave,
  }));

  const { contestList } = useSelector(contestSelector);
  const { comments, isLoading, isSaving, isCommentSave } =useSelector(commentsSelector);

  const [sketchData, setSketchData] = useState({
    name: "",
    description: "",
    media: [],
  });

  useEffect(() => {
    dispatch(onGetContestDetailThunk({ contestId: contestId }));

    dispatch(onGetContestComments({ contest_id: contestId })).then(
      (response) => {
        // console.log("API response from getContestComments:", response);
      }
    );

  }, [dispatch, contestId]);

  // Store contestList in state
  useEffect(() => {
    if (contestList && contestList.id) {
      setContestDetail(contestList);
    }
  }, [contestList]);

  // Set sketch data and parse countdown
  useEffect(() => {
    if (contestDetail && contestDetail.id) {
      setSketchData({
        id: contestDetail.id || null,
        timeLeft: contestDetail.timeLeft || 0,
        name: contestDetail.contestCategory || null,
        description: contestDetail.contestDescription || "",
        media: contestDetail.contestMedia || [],
      });

        if(contestDetail.isPremiumUser==1){
        setIsPremiumUser(true)
        }

    }
  }, [contestDetail]);

  useEffect(() => {
    if (sketchData.timeLeft != 0) {
      setIsShowTimer(true);
    } else {
      setIsShowTimer(false);
    }
  }, [role, sketchData.timeLeft]);

  // Refresh comments after saving a new comment
  useEffect(() => {
    if (isCommentSave) {
      dispatch(onGetContestComments({ contest_id: contestId }));
    }
  }, [isCommentSave, dispatch, contestId]);

  const handleSaveComment = (commentData) => {
    dispatch(onSaveContestComments(commentData));
  };

  return (
    <>
   
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
        <Header title={"Contest"} showBack={true} />
      </header>

      <div className="w-full bg-[#F7F7F7]">
        <div className="w-full  mx-auto flex flex-col items-start justify-center gap-12 lg:flex-row mt-4">
          {/* Left Side */}
          <div className="w-full lg:w-[40%] flex">
            <SketchDetails
              name={sketchData.name}
              description={sketchData.description}
              sketchMedia={sketchData.media}
              isShowDetail={isShowTimer ? 1 : 2}
              contestId={contestId}
             isResultUploads={contestDetail?.uploadedResults?.length > 0 ? 1 : 2}
             sketchData={sketchData}
             contestData={contestDetail}
            />
          </div>

          {/* Right Side */}
          <div className="w-full flex flex-col items-start justify-start lg:w-[60%]">
            {contestDetail?.contestResult ? (
              <div className="w-full h-full flex flex-col items-start justify-center">
                <SketchResult result={contestDetail.contestResult} />
              </div>
            ) : isShowTimer ? (
              <div className="cursor-pointer w-full min-h-[584px] h-full flex flex-col items-center justify-center border-2 border-dashed border-border_color rounded-[14px]">
                <CountdownTimer
                  timeLeft={contestDetail?.timeLeft}
                  contestId={contestId}
                />
              </div>
            ) : contestDetail?.status !== "Created" ? (
              <div className="w-full h-full flex items-start justify-center">
                <CreateContest
                  description={sketchData.description}
                  contestId={contestId}
                  isPremiumUser={isPremiumUser}
                />
              </div>
            ) : (
              <ContestMessage message={"Contest share with artists"} />
            )}


        {isPremiumUser && (
  <div className="w-full mt-4">
    <CommentCheck
      contestId={contestId}
      comments={comments}
      isLoading={isLoading}
      isSaving={isSaving}
      onSaveComment={handleSaveComment}
    />
  </div>
)}


          </div>

        </div>
      </div>
    </>
  );
};
